import { Edge, Node } from '@xyflow/react';
// import { FlashIconFlow, PlayIconFlow } from "../../../assets/images";

export const initialNodes: Node[] = [
  {
    id: '1',
    type: 'custom',
    data: {
      // icon: FlashIconFlow,
      title: 'Select Trigger',
      description: 'Empty trigger',
      selected: false,
      trigger_type: '',
      nodeComplete: false,
      node_type: 'trigger',
    },
    position: { x: 50, y: 0 },
  },
  {
    id: '2',
    type: 'custom',
    data: {
      // icon: PlayIconFlow,
      title: 'Select Action',
      description: 'Empty action',
      selected: false,
      nodeComplete: false,
      node_type: 'action',
    },
    position: { x: 50, y: 150 },
  },
  {
    id: 'end',
    type: 'end',
    data: { title: 'End', node_type: 'end', description: '' },
    position: { x: 175, y: 300 },
    selected: false,
  },
];

export const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', type: 'custom' },
  { id: 'e2-3', source: '2', target: 'end', type: 'custom' },
];

export const pageTitle = 'Automator';
export const newProjectText = 'New Project';
export const existingProjectsText = 'Existing Projects';
export const editText = 'Edit';
export const deleteText = 'Delete';
export const shareText = 'Share';
export const createdBy = 'Created by :';
export const viewDetails = 'View Details';
export const requiredText = 'This field is required.';
export const noProjectText = 'No Projects Found!';
export const savingText = 'Saving...';
export const testAgainText = 'Test Again';
export const triggerType = 'Trigger Type :';
export const workflowStatus = 'Status :';

export const methods: Array<{ id: string; label: string; value: string }> = [
  { id: 'GET', label: 'GET', value: 'GET' },
  { id: 'POST', label: 'POST', value: 'POST' },
];

export const bodyTypes: Array<{ id: string; label: string; value: string }> = [
  { id: 'JSON', label: 'JSON', value: 'JSON' },
  { id: 'Form', label: 'Form', value: 'FORM' },
];

export const successFulltext = 'Successful!';
export const RenderSchedulerContent =
  "Your Schedule has been successfully set up. We'll run your workflow at the scheduled time.";
export const WebhookApiText = 'Your Webhook API URL';
export const RenderWebhookContent =
  "You'll need to configure your application with this grigo Webhook API URL.";
export const ListeningText = "We're listening";
export const RenderWebhookContentTwo =
  "To confirm your trigger is set up correctly, we'll find recent requests in your account.";
export const TriggerRes = 'Stored Trigger Response:';
export const WebhookApiResponse = 'Run your Webhook API to get response';
